import script from "./editResume.vue?vue&type=script&setup=true&lang=js"
export * from "./editResume.vue?vue&type=script&setup=true&lang=js"

import "./editResume.vue?vue&type=style&index=0&id=7633e474&lang=less"
import "./editResume.vue?vue&type=style&index=1&id=7633e474&scoped=true&lang=less"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7633e474"]])

export default __exports__